/**
 * Enable multiple places checkbox on hotels form, when checked triggers the "multi property" shopping in PWA by setting a query parameter in the URL: multiProp=true
 * This is managed by `wizard-hotel-pwa-v2` module (https://flexmanager.prod.expedia.com/#/moduleStore/show/255)
 */
import * as React from "react";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkCheckbox } from "uitk-react-switch";

import { useLocalization } from "@shared-ui/localization-context";

import { locKeys } from "components/flexComponents/WizardHotelPWA/components/l10n";
import { MultiplePlacesProps } from "../typings";

const { needMultiplePlaces } = locKeys;

export const MultiplePlaces = ({ disabled, hotelWizardState, isChecked, colSpan }: MultiplePlacesProps) => {
  const { formatText } = useLocalization();

  const handleCheckboxChange = () => {
    hotelWizardState.toggleMultiplePlacesCheckbox();
  };

  return (
    <UitkLayoutGridItem colSpan={colSpan}>
      <div>
        <UitkCheckbox
          id="multiProp"
          label={formatText(needMultiplePlaces)}
          checked={hotelWizardState.isMultiplePlacesChecked}
          onChange={handleCheckboxChange}
          disabled={disabled}
          value={String(isChecked)}
        />
      </div>
    </UitkLayoutGridItem>
  );
};
